<div class="panel panel-success">
    <div class="panel-heading">
        <h5 style="display: inline-block">
            <span>Snap shot </span>
        </h5>
    </div>
    <div class="panel-body panel-list">
        <!--<div *ngIf="processing" class="list-group" style="overflow-y:scroll; max-height: 600px;">
            <i class="fa fa-spinner fa-spin"></i> Loading projects...
        </div>-->
        <div class="panel-group" style="height:370px">
            <div style="padding: 0;">
                <div class="panel-group">
                    <div class="panel company-panel" *ngFor="let i of SnapShoDatetLst">
                        <div class="panel-heading" >
                            <h5 style="display: inline-block;">
                                <span [ngClass]="textColor">{{i.Date}}</span>
                            </h5>
                            <div class="pull-right btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-sm">
                                    <button type="button" class="btn btn-info" title="Restore to this snapshot" (click)="ShowModal(i.Date)">
                                        <span data-toggle="tooltip" class="fa fa-undo fa-lg"></span>
                                    </button>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div bsModal #Snapshot="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Restore to Date: {{Date}}
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to restore to date {{Date}}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="Restore()">Confirm Restore</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>